import { html } from "htm/preact";
import { render } from "preact";
import FeatureFilters from "../components/FeatureFilters.js";

const el = document.getElementById("feature-filters-island");
if (el) {
  render(html`<${FeatureFilters} />`, el);
}
